// Investiture
import React from 'react';
import { Investiture2026 } from '../views';

const InvestiturePage = () => {
  return <Investiture2026 />;
};

export default InvestiturePage;
